module.exports = __webpack_public_path__ + "img/flogo.84e0cf5c.png";